var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.sample_count)?_c('b-badge',{attrs:{"variant":_vm.variant,"pill":""}},[_vm._v("\n    "+_vm._s(_vm.percent)+"%\n  ")]):_c('b-badge',{attrs:{"variant":"","pill":""}},[_vm._v("\n    N/A\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }